module.exports = __webpack_public_path__ + "img/fig05.a4f6072c.jpg";